function parseDateValue(value) {
  if (!value) return null

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value
  }

  if (typeof value === 'number') {
    const date = new Date(value)
    return Number.isNaN(date.getTime()) ? null : date
  }

  if (typeof value === 'string') {
    const trimmedValue = value.trim()
    if (!trimmedValue) return null

    const normalizedValue = trimmedValue.includes('T')
      ? trimmedValue
      : trimmedValue.replace(' ', 'T')

    const parsedValue = new Date(normalizedValue)
    if (!Number.isNaN(parsedValue.getTime())) {
      return parsedValue
    }

    const match = trimmedValue.match(
      /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/
    )

    if (match) {
      const year = Number(match[1])
      const month = Number(match[2]) - 1
      const day = Number(match[3])
      const hour = Number(match[4] || 0)
      const minute = Number(match[5] || 0)
      const second = Number(match[6] || 0)
      const localDate = new Date(year, month, day, hour, minute, second)
      return Number.isNaN(localDate.getTime()) ? null : localDate
    }
  }

  const fallbackDate = new Date(value)
  return Number.isNaN(fallbackDate.getTime()) ? null : fallbackDate
}

export function formatDateTime(value) {
  const date = parseDateValue(value)
  if (!date) return '-'

  return new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'short',
    timeZone: 'America/Sao_Paulo'
  }).format(date)
}